import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String };
  static targets = ['chartcanvas'];
  static aspectRatio = 1;

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);

    const chartOptions = {
      responsive: true,
      aspectRatio: this.constructor.aspectRatio,
      cutout: '70%',
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };

    const centerText = {
      id: 'centerText',
      afterDatasetsDraw(chart, _args, _pluginOptions) {
        const { ctx, data } = chart;

        const text = data.donutCenterText || '';

        ctx.save();
        const x = chart.getDatasetMeta(0).data[0].x;
        const y = chart.getDatasetMeta(0).data[0].y;

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = '12px sans-serif';

        // This sets the font color
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.fillText(text, x, y);
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'doughnut',
      data: chartData,
      options: chartOptions,
      plugins: [centerText],
    });
  }
}
